import React, { useContext, useEffect, useState } from "react";
import AdminLayout from "../../../components/layouts/adminLayout";
import AdminPageContainer from "../../../components/AdminPageContainer";
import { useNavigate } from "react-router";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import AuditLogService from "../../../services/API/AuditLogService";
import Pagination from "react-js-pagination";
import { Modal } from "react-bootstrap";
import moment from "moment";

export default function Enquiries() {
  const [page, setPage] = useState(1);
  const [show, setShow] = useState(false);
  const [myData, setMyData] = useState([]);
  const [id, setId] = useState(null);
  const [edit, setEdit] = useState(false);
  const [displaySearchField, setDisplaySearchField] = useState(false);
  const [searchkey, setSearchkey] = useState(null);
  const [filter, setFilter] = useState(false);
  const [q, setq] = useState("");
  const [limit, setLimit] = useState(20);
  const [sortColumn, setSortColumn] = useState('id');
  const [sortOrder, setSortOrder] = useState('desc');
  const postsPerPage = 20;
  const [loader, setLoader] = useState("");

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const startIndex = +(page - 1) * limit;
  const endIndex = parseInt(startIndex + limit);

  const queryKey = "api/list-enquiries";
  const {
    data: enquiry,
    isLoading: loading,
    isSuccess: success,
    isFetching,
    refetch,
  } = useQuery([
    queryKey,
    {
      ...filter,
      q,
      limit: limit,
      page: page,
      start: startIndex,
      end: endIndex,
      sortColumn: sortColumn,
      sortOrder: sortOrder
    },
  ], AuditLogService.getEnquiryList, {
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });

  const enquiries = enquiry?.data?.data;

  useEffect(() => {
    if (enquiry?.data?.data) {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      setMyData(enquiry?.data?.data);
    }
  }, [enquiry, page, sortColumn, sortOrder, startIndex, endIndex]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [page]);

  const navigate = useNavigate();

  const handleEdit = async (log) => {
    try {
      const logData = await AuditLogService.editEnquiryList(log?.id);

      setId(log?.id);
      setEdit(logData?.data);
      if (logData?.data) {
        setShow(true);
      }
    } catch (er) {
      toast.error(er);
    }
  };

  const handleHide = () => {
    setShow(false);
  };
  //TECH-53181 to ui fix
const renderEllipsisCell = (value, maxWidth = "200px") => {
  return (
    <td
      className="text-start align-middle"
      style={{
        maxWidth,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        cursor: "pointer"
      }}
      title={value}
    >
      {value || "-"}
    </td>
  );
};
  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortColumn(column);
      setSortOrder('asc');
    }
  };
  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  function getLabel(str) {
    return str
      .split('_')                    // split by underscore
      .map(word => capitalizeFirstLetter(word))
      .join(' ');                    // join with spaces (or '' if you want)
  }

  const downloadReport = async () => {
    setLoader("download");
    const resp = await AuditLogService.downloadEnquiryReport();
    setLoader("");
    if (resp) {
      const url = window.URL.createObjectURL(new Blob([resp]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Enquiry-Lists.csv");
      toast.success("Enquiry Report Downloaded Successfully");
      link.click();
    }
  };

  return (
    <AdminLayout test="active">
      <AdminPageContainer>
        <div id="main" role="main">
          <div id="content">
            <div>
              <ol className="breadcrumb">
                <li className="breadcrumb-item ">
                  <a
                    style={{
                      color: "blue",
                      cursor: "pointer",
                    }}
                    onClick={() => navigate("/customer-support/dashboard")}
                    onKeyDown={() => navigate("/customer-support/dashboard")}
                  >
                    Home
                  </a>
                </li>
                <li className="breadcrumb-item active">Enquiry Lists</li>
              </ol>
            </div>

            <div>
              <div className="row">
                <div className="card card-sm card-shadow mb-3">
                  <div className="card-body">
                    <div className="d-flex justify-content-between">
                      <h2
                        style={{
                          fontWeight: "bold",
                          marginBottom: "0",
                        }}
                      >
                        Enquiry Lists
                      </h2>
                    </div>

                    <div style={{ borderTop: "0px" }}>
                      <div className="d-flex justify-content-end align-items-center gap-2 pb-3">
                        {(!!filter?.name ||
                          !!filter?.email ||
                          !!filter?.mobile ||
                          !!q) && (
                            <button
                              type="button"
                              className="button_new pull-right mt-1 px-3"
                              onClick={() => {
                                setq("");
                                setDisplaySearchField(false);
                                setFilter("");
                              }}
                            >
                              Clear Filters
                            </button>
                          )}
                        {displaySearchField ? (
                          <label className="input m-0 mt-1">
                            <input
                              type="text"
                              className="button_new "
                              value={q}
                              onChange={(e) => {
                                setPage(1);
                                setq(e.target.value);
                              }}
                              placeholder="Search"
                            />
                          </label>
                        ) : (
                          <div>
                            <a
                              className=" button_new "
                              onClick={() => {
                                setDisplaySearchField(true);
                              }}
                              onKeyDown={() => {
                                setDisplaySearchField(true);
                              }}
                            >
                              <i
                                class="fa fa-fa fa-search requests-icons"
                                title="Search"
                                aria-hidden="true"
                              ></i>
                            </a>
                          </div>
                        )}
                        <div>
                          <a
                            onClick={() => downloadReport()}
                            onKeyDown={() => downloadReport()}
                            target="_blank"
                            className="button_new"
                          >
                            <i
                              className="fa fa-download requests-icons"
                              title="Download"
                            ></i>
                          </a>
                        </div>
                      </div>
                 

                      <div className="table-responsive ">
                        <table
                          className="table  table-bordered table-hover dataTable no-footer"
                          style={{ tableLayout: "fixed" }}
                        >
                          <thead>
                            <tr role="row" style={{ fontWeight: 700 }}>
                              <th className="text-center" width="34px">
                                S. No.
                              </th>
                              <th
                                onClick={() => handleSort('name')}
                                 style={{width:'100px'}}
                                className={`text-center align-top py-2 td-sr ${sortColumn === 'name' ? (sortOrder === 'asc' ? 'sorting_asc' : 'sorting_desc') : 'sorting'}`}
                                aria-sort={sortColumn === 'name' ? (sortOrder === 'asc' ? 'ascending' : 'descending') : 'none'}
                              >
                                Name
                              </th>
                              <th
                                onClick={() => handleSort('mobile')}
                                style={{width:'65px'}}
                                className={`text-center align-top py-2 td-sr ${sortColumn === 'mobile' ? (sortOrder === 'asc' ? 'sorting_asc' : 'sorting_desc') : 'sorting'}`}
                                aria-sort={sortColumn === 'mobile' ? (sortOrder === 'asc' ? 'ascending' : 'descending') : 'none'}
                              >
                                Mobile
                              </th>
                              <th
                                onClick={() => handleSort('email')}   style={{ width: "120px" }}
                                className={`text-center align-top py-2 td-sr ${sortColumn === 'email' ? (sortOrder === 'asc' ? 'sorting_asc' : 'sorting_desc') : 'sorting'}`}
                                aria-sort={sortColumn === 'email' ? (sortOrder === 'asc' ? 'ascending' : 'descending') : 'none'}
                              >
                                Email
                              </th>
                              <th
                                onClick={() => handleSort('company_name')}
                                 style={{ width: "150px" }}
                                className={`text-center align-top py-2 td-sr ${sortColumn === 'company_name' ? (sortOrder === 'asc' ? 'sorting_asc' : 'sorting_desc') : 'sorting'}`}
                                aria-sort={sortColumn === 'company_name' ? (sortOrder === 'asc' ? 'ascending' : 'descending') : 'none'}
                              >
                                Company Name
                              </th>
                              {/* <th
                                onClick={() => handleSort('type')}
                                 style={{ width: "250px" }}
                                className={`text-center align-top py-2 td-sr ${sortColumn === 'type' ? (sortOrder === 'asc' ? 'sorting_asc' : 'sorting_desc') : 'sorting'}`}
                                aria-sort={sortColumn === 'type' ? (sortOrder === 'asc' ? 'ascending' : 'descending') : 'none'}
                              >
                                Enquiry For
                              </th> */}
                              {/* TECH-53181 User Status add */}
                              <th
                                onClick={() => handleSort('user_id')}
                                 style={{ width: "70px" }}
                                className={`text-center align-top py-2 td-sr ${sortColumn === 'user_id' ? (sortOrder === 'asc' ? 'sorting_asc' : 'sorting_desc') : 'sorting'}`}
                                aria-sort={sortColumn === 'user_id' ? (sortOrder === 'asc' ? 'ascending' : 'descending') : 'none'}
                              >
                               User Status
                              </th>

                              <th
                                onClick={() => handleSort('created_at')}
                                 style={{ width: "93px" }}
                                className={`text-center align-top py-2 td-sr ${sortColumn === 'created_at' ? (sortOrder === 'asc' ? 'sorting_asc' : 'sorting_desc') : 'sorting'}`}
                                aria-sort={sortColumn === 'created_at' ? (sortOrder === 'asc' ? 'ascending' : 'descending') : 'none'}
                              >
                                Created Date
                              </th>
                              <th className="text-center" width="50px">
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {enquiries?.length !== 0 ? (
                              enquiries?.map((log, index) => {
                                return (
                                  <tr key={log?.id}>
                                    <td className="text-start align-middle">
                                      {postsPerPage * (page - 1) + index + 1}
                                    </td>
                                    <td className="text-start align-middle">
                                      {log?.name}
                                    </td>
                                    <td className="text-start align-middle" style={{width:'80px'}}>
                                      {log?.mobile}
                                    </td>
                                     {/* TECH-53181 ui fix  */}
                                   {renderEllipsisCell(log?.email, "150px")}
                                   {renderEllipsisCell(log?.company_name, "220px")}
                                   {/* {renderEllipsisCell(log?.type, "200px")} */}
                                    {/* TECH-53181 User Status add */}
                                    <td className="text-start align-middle">
                                      {log?.user_id == 0 ? "Unregistered" : "Registered"}
                                    </td>
                                    <td className="text-start align-middle">
                                      {moment(log?.created_at).isValid()
                                        ? moment(log?.created_at).format("DD-MM-YY hh:mm A")
                                        : "-"}

                                    </td>
                                    <td className="text-start align-middle">
                                      <a
                                        title="View"
                                        onClick={() => handleEdit(log)}
                                        onKeyDown={() => handleEdit(log)}
                                      >
                                        <i className="fa fa-eye fa-fw cursor-pointer"></i>
                                      </a>
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan={6} className="p-2 text-center">
                                  {loading || isFetching
                                    ? "Loading..."
                                    : "No data found"}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        {enquiry?.data?.count > postsPerPage && (
                          <Pagination
                            activePage={page}
                            itemsCountPerPage={postsPerPage}
                            totalItemsCount={enquiry?.data?.count}
                            pageRangeDisplayed={postsPerPage}
                            onChange={handlePageChange}
                          />
                        )}
                      </div>

                      {show && (
                        <Modal
                          show={show}
                          animation={false}
                          onHide={handleHide}
                          dialogClassName="modal-lg"
                        >
                          <Modal.Header closeButton>
                            <h3 className="modal-title">View</h3>
                          </Modal.Header>
                          <Modal.Body
                            style={{ height: "80vh", overflowY: "scroll" }}
                          >
                            <div className="table-responsive ">
                              <table
                                className="table  table-bordered table-hover dataTable no-footer"
                                style={{ tableLayout: "fixed" }}
                              >
                                <thead>
                                  <tr role="row" style={{ fontWeight: 700 }}>
                                    <th className="text-center" style={{width:'150px'}}>Key</th>
                                    <th className="text-center">Value</th>
                                  </tr>
                                </thead>
                                <tbody>
                                   {/* TECH-53181 User Status add in view  */}
                                  {Object.entries(edit).map(([key, value]) => {
                                    if (!value && value !== 0) return null; // allow 0

                                    let displayValue = value;

                                    if (key === "User Status") {
                                      displayValue = value == 0 ? "Unregistered" : "Registered";
                                    }

                                    return (
                                      <tr key={key}>
                                        <td className="text-start align-middle">
                                          {getLabel(key)}
                                        </td>
                                        <td className="text-start align-middle">
                                          {displayValue}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </Modal.Body>
                        </Modal>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </AdminPageContainer>
    </AdminLayout>
  );
}
